import { render } from "./RegistrationTicketWristband.vue?vue&type=template&id=4e7d23e1"
import script from "./RegistrationTicketWristband.vue?vue&type=script&lang=js"
export * from "./RegistrationTicketWristband.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__